module.exports = __webpack_public_path__ + "static/media/card3.27eaf2ff.jpg";